// 传参说明：
// timer.countDown(时间戳或时间, 时间每隔一秒更新一次的回调函数)

// 注： 如果中途想停止倒计时可调用 timer.timerSwitch = false， 立即终止倒计时。

// 定义一个函数的方式实现倒计时

/**
 * 返回参数解释：
 * @days 天数
 * @hours 小时数
 * @minutes 分钟数
 * @seconds 秒数
 * @isEnd 是否倒计时结束
 */
export function Timer() {
  this.timerSwitch = true
  this.countDown = (endTime, updateTime) => {
    let currentDate = new Date()
    let endDate = new Date(endTime)
    if (currentDate >= endDate) {
      updateTime.call(this, {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isEnd: true
      })
    } else {
      let timeRemaining = Math.ceil((endDate - currentDate) / 1000) // 计算剩余的毫秒数
      let days = Math.floor(timeRemaining / 60 / 60 / 24) // 计算剩余的天数
      let hours = Math.floor(timeRemaining / 60 / 60 % 24).toString().padStart(2, 0) // 计算剩余的小时
      let minutes = Math.floor(timeRemaining / 60 % 60).toString().padStart(2, 0) // 计算剩余的分钟
      let seconds = Math.floor(timeRemaining % 60).toString().padStart(2, 0) // 计算剩余的秒数
      let isEnd = false // 是否结束
      updateTime.call(this, {
        days,
        hours,
        minutes,
        seconds,
        isEnd
      })
      if (this.timerSwitch) {
        setTimeout(() => {
          this.countDown(endTime, updateTime)
        }, 1000)
      }
    }
  }
}
